import { render, staticRenderFns } from "./Zhanyan.vue?vue&type=template&id=6026c797&"
var script = {}
import style0 from "./Zhanyan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports